export default __webpack_public_path__ + "static/media/s3.523973c0.jpg";